import { getDashboardRoute } from 'utils/dashboardRoute';

import { useCampaignsDashboardRedesignAllowed } from 'hooks/useCampaignsDashboardRedesignAllowed';

export const useDashboardRoute = (): string => {
    const isCampaignsDashboardRedesign = useCampaignsDashboardRedesignAllowed();

    return getDashboardRoute(isCampaignsDashboardRedesign);
};
